import React from "react";
import {
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCardImage,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { excerpt } from '../utils/Excerpt'

const RelatedTours = ({ relatedTours, tourId }) => {
    return (
        <>
            {relatedTours && relatedTours.length > 0 && (
                <>
                    {relatedTours.length > 1 && <h4 className="py-3">Related Tours</h4>}
                    <MDBRow className="row-cols-1 row-cols-md-3 mb-5 g-4">
                        {relatedTours
                            .filter((item) => item._id !== tourId)
                            .splice(0, 3)
                            .map((item) => (
                                <MDBCol>
                                    <MDBCard>
                                        <Link to={`/tour/${item._id}`}>
                                            <MDBCardImage
                                                src={item.imageFile}
                                                alt={item.title}
                                                position="top"
                                                style={{ maxWidth: "100%", height: "180px" }}
                                            />
                                        </Link>
                                        <span className="text-start tag-card">
                                            {item.tags.map((tag, index) => (
                                                <Link key={index} to={`/tours/tag${tag}`}> #{tag}</Link>
                                            ))}
                                        </span>
                                        <MDBCardBody>
                                            <MDBCardTitle className="text-start">
                                                {item.title}
                                            </MDBCardTitle>
                                            <MDBCardText className="text-start">
                                                {excerpt(item.description, 45)}
                                            </MDBCardText>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>
                            ))}
                    </MDBRow>
                </>
            )}
        </>
    );
};

export default RelatedTours;